import React, { useState, useEffect, useRef } from "react";
import IconHealthInfo from "assets/icons/HealthInfo-icon.svg";
import IconArrowDown from "assets/icons/expandAllIcon.svg";
import { Accordion, Card, Button } from "react-bootstrap";
import Spinner from "react-bootstrap/Spinner";

function AccordianNestleOmegaPlus({ nestle_omega_plus }) {
  const isCancelled = useRef(false);
  const [meals, setMeals] = useState(0);
  const [questions, setQuestions] = useState([]);
  const [cholesterol, setCholesterol] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getNOPInfo();

    return () => {
      isCancelled.current = true;
    };
  }, []); // eslint-disable-line

  const getNOPInfo = () => {
    setLoading(true);
    setQuestions(nestle_omega_plus.questionnaire);
    setCholesterol(nestle_omega_plus.cholesterol);
    setMeals(nestle_omega_plus.meals_uploaded);
    setLoading(false);
  };

  return (
    <>
      <Card className="nop-info card-accordian">
        <Card.Header>
          <Accordion.Toggle as={Button} variant="link" eventKey="2">
            <div className="header-title">
              <img
                src={IconHealthInfo}
                alt="icon-info-circle"
                className="title-icon"
              />
              <div className="title">NESTLÉ® Omega Plus</div>
            </div>
            <div>
              <img src={IconArrowDown} alt="icon-arrow-down" />
            </div>
          </Accordion.Toggle>
        </Card.Header>
        <Accordion.Collapse eventKey="2">
          <Card.Body>
            {loading ? (
              <div className="loader">
                <Spinner animation="border" className="spinner" />
              </div>
            ) : (
              <>
                {questions.map((q, i) => (
                  <div className="info-row" key={`quiz-${i}`}>
                    <div
                      className="label"
                      dangerouslySetInnerHTML={{ __html: q.question }}
                    />
                    <div className="info">{q.answer}</div>
                  </div>
                ))}
                <div className="info-row">
                  <div className="label">Number of meals uploaded</div>
                  <div className="info">{meals}</div>
                </div>

                <div className="info-row">
                  <div className="label">Total Cholesterol (mmol/L)</div>
                  <div className="info">{cholesterol}</div>
                </div>
              </>
            )}
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </>
  );
}

export default AccordianNestleOmegaPlus;
